import script from "./AddNewGroupTalkUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewGroupTalkUsers.vue?vue&type=script&setup=true&lang=js"

import "./AddNewGroupTalkUsers.vue?vue&type=style&index=0&id=38250c43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38250c43"]])

export default __exports__